var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './language.service';
import { CustomNgbDateParserFormatter } from '../models/custom-ngb-date-parser-formatter';
/**
 * Custom implementation of NgbDatepickerI18n (ng-bootstrap/datepicker)
 *
 * @export
 * @class ClxDatepickerI18nService
 * @extends {NgbDatepickerI18n}
 */
var ClxDatepickerI18nService = /** @class */ (function (_super) {
    __extends(ClxDatepickerI18nService, _super);
    function ClxDatepickerI18nService(language, translate) {
        var _this = _super.call(this) || this;
        _this.language = language;
        _this.translate = translate;
        return _this;
    }
    ClxDatepickerI18nService.prototype.getWeekdayShortName = function (weekday) {
        return this.language.getWeekdayShortName(weekday);
    };
    ClxDatepickerI18nService.prototype.getMonthShortName = function (month, year) {
        return this.language.getMonthShortName(month);
    };
    ClxDatepickerI18nService.prototype.getMonthFullName = function (month, year) {
        return this.language.getMonthFullName(month);
    };
    ClxDatepickerI18nService.prototype.getDayAriaLabel = function (date) {
        return this.language.getDayAriaLabel(CustomNgbDateParserFormatter.toDate(date));
    };
    return ClxDatepickerI18nService;
}(NgbDatepickerI18n));
export { ClxDatepickerI18nService };
